angular.module('rings-app.directives.recovery', ['usersService'])
/*
* Directive to display form to change the user
*/
.directive('recovery', ['$rootScope','codebookService',function($rootScope,codebookService){
  return {
    restrict: 'AE',
    templateUrl : 'home/recovery-form.tpl.html',
    scope : { }, 																						// isolated scope
    controllerAs : 'recoveryCtrl',
    bindToController: true,
    controller : function (){

    	// variables
    	var self = this;

        // variables
        self.alive = null;
        self.species = null;
        self.age = null;
        self.sex = null;
        // ring information
        self.scheme = null;
        self.ringnumber = null;
        // location
        self.locality = new Locality();
        // date and time
        self.date = null;
        self.time = null;
        self.datePickerOpened = false;
        // user
    	self.userInfo = angular.copy($rootScope.user);
        if (typeof(self.userInfo) === 'undefined'){
            self.userInfo = {
                UID: null
            }
        }        
        // map options
        self.mapOption = {
          lat: 49.8,
          lng: 15.50,
          zoom: 6
        }

        // ringing scheme list
        self.ringingscheme = [];
        self.privateAge = [];
        codebookService.fetchCodebook('ringingscheme',false)
          .then(function(data){
            self.ringingscheme = data.ringingscheme;
            self.privateAge = data.age;
          }, function(data){
            alert(data);
          });

        // public age
        self.publicAge = [
        {"Id": null,"description": ""}
        ,{"Id": 200,"description": "Mládě"}
        ,{"Id": 360,"description": "Dospěný jedinec"}];

        // open calendar
        self.openDatePicker = function(){
          self.datePickerOpened = true;
        }

        // when autocompleter option for species is selected, update model
        this.updateSpecies = function (selectedValue) {
        // if the user clears the input box        
        if (!selectedValue) {
            self.species = null;
            return;
        }
        self.species = selectedValue.originalObject; 
        };
    }
  }
}]);